import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingService } from '../../core/services/loading.service';
import { environment } from '../../../assets/env/env.local';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  readonly isLoading$ = this.loadingService.isLoading$;
  readonly loaderColor = environment.LOADER_COLOR ?? '#000000';

  constructor(private loadingService: LoadingService) {}
}
